type SvgProps = React.SVGProps<SVGSVGElement>;
export const DragIcon = (props: SvgProps) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0832 5.5C9.394 5.5 8.83317 4.93917 8.83317 4.25C8.83317 3.56083 9.394 3 10.0832 3C10.7723 3 11.3332 3.56083 11.3332 4.25C11.3332 4.93917 10.7723 5.5 10.0832 5.5ZM10.0832 13C9.394 13 8.83317 12.4392 8.83317 11.75C8.83317 11.0608 9.394 10.5 10.0832 10.5C10.7723 10.5 11.3332 11.0608 11.3332 11.75C11.3332 12.4392 10.7723 13 10.0832 13ZM10.0832 9.25C9.394 9.25 8.83317 8.68917 8.83317 8C8.83317 7.31083 9.394 6.75 10.0832 6.75C10.7723 6.75 11.3332 7.31083 11.3332 8C11.3332 8.68917 10.7723 9.25 10.0832 9.25ZM5.9165 5.5C5.22734 5.5 4.6665 4.93917 4.6665 4.25C4.6665 3.56083 5.22734 3 5.9165 3C6.60567 3 7.1665 3.56083 7.1665 4.25C7.1665 4.93917 6.60567 5.5 5.9165 5.5ZM5.9165 13C5.22734 13 4.6665 12.4392 4.6665 11.75C4.6665 11.0608 5.22734 10.5 5.9165 10.5C6.60567 10.5 7.1665 11.0608 7.1665 11.75C7.1665 12.4392 6.60567 13 5.9165 13ZM5.9165 9.25C5.22734 9.25 4.6665 8.68917 4.6665 8C4.6665 7.31083 5.22734 6.75 5.9165 6.75C6.60567 6.75 7.1665 7.31083 7.1665 8C7.1665 8.68917 6.60567 9.25 5.9165 9.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
